/**
 * Build CSV content from headers and rows, then trigger a browser download.
 *
 * @param {string[]} headers  - Column header labels
 * @param {Array<Array<string|number>>} rows - 2-D array of cell values
 * @param {string} [filename="export.csv"] - Download file name
 */
export const downloadCsv = (headers, rows, filename = "export.csv") => {
    const escapeCsv = (cell) => `"${String(cell ?? "").replace(/"/g, '""')}"`
    const csvContent = [headers, ...rows]
        .map((row) => row.map(escapeCsv).join(","))
        .join("\n")

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
    const url = URL.createObjectURL(blob)
    const link = document.createElement("a")
    link.href = url
    link.download = filename
    link.click()
    URL.revokeObjectURL(url)
}
